module.exports = __webpack_public_path__ + "static/the-business-model-canvas.2cac15a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/the-business-model-canvas.png
// module id = 896
// module chunks = 101846417399083